/**
 * Controls dragging behavior for widgets
 */
export class WidgetDragController {
    constructor({ onDragMove }) {
        Object.defineProperty(this, "isDragging", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isDragEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "initialMouseX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "initialMouseY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "initialLeft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "initialTop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "dragHandle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "container", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "onDragMove", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.onDragMove = onDragMove;
        this.handlers = {
            mouseMove: (e) => {
                if (!this.isDragging || !this.container)
                    return;
                const newX = e.clientX - this.initialMouseX;
                const newY = e.clientY - this.initialMouseY;
                this.onDragMove({ x: newX, y: newY });
            },
            mouseDown: (e) => {
                // Don't start dragging if disabled
                if (!this.isDragEnabled || !this.container || !this.dragHandle)
                    return;
                const target = e.target;
                if (target !== this.dragHandle && !this.dragHandle.contains(target)) {
                    return;
                }
                this.isDragging = true;
                this.initialLeft = parseInt(this.container.style.left) || 0;
                this.initialTop = parseInt(this.container.style.top) || 0;
                this.initialMouseX = e.clientX - this.initialLeft;
                this.initialMouseY = e.clientY - this.initialTop;
                document.addEventListener('mousemove', this.handlers.mouseMove);
                document.addEventListener('mouseup', this.handlers.mouseUp);
                e.preventDefault();
            },
            mouseUp: () => {
                this.isDragging = false;
                this.removeDraggingListeners();
            },
        };
    }
    /**
     * Enables dragging functionality
     */
    enableDragging() {
        this.isDragEnabled = true;
        if (this.dragHandle) {
            this.dragHandle.style.cursor = 'move';
        }
    }
    /**
     * Disables dragging functionality
     */
    disableDragging() {
        this.isDragEnabled = false;
        // Stop any active dragging
        if (this.isDragging) {
            this.isDragging = false;
            this.removeDraggingListeners();
        }
        // Update cursor to indicate dragging is disabled
        if (this.dragHandle) {
            this.dragHandle.style.cursor = 'default';
        }
    }
    /**
     * Checks if dragging is enabled
     */
    isDragEnabledState() {
        return this.isDragEnabled;
    }
    /**
     * Sets up the drag handle element
     */
    setupDragHandle() {
        if (!this.dragHandle)
            return;
        // Add mousedown event to drag handle
        this.dragHandle.addEventListener('mousedown', this.handlers.mouseDown);
    }
    removeDraggingListeners() {
        document.removeEventListener('mousemove', this.handlers.mouseMove);
        document.removeEventListener('mouseup', this.handlers.mouseUp);
    }
    /**
     * Initializes the controller with necessary DOM elements
     */
    initialize(container, dragHandle) {
        this.container = container;
        this.dragHandle = dragHandle;
        // Set up the drag handle event
        this.setupDragHandle();
    }
    /**
     * Checks if dragging is active
     */
    isDraggingActive() {
        return this.isDragging;
    }
    /**
     * Gets the current dragging position (during active drag)
     */
    getCurrentDragPosition(e) {
        if (!this.isDragging) {
            return { x: 0, y: 0 };
        }
        const x = e.clientX - this.initialMouseX;
        const y = e.clientY - this.initialMouseY;
        return { x, y };
    }
    /**
     * Cleans up the controller
     */
    cleanup() {
        this.removeDraggingListeners();
        if (this.dragHandle) {
            const newElement = this.dragHandle.cloneNode(false);
            if (this.dragHandle.parentNode) {
                this.dragHandle.parentNode.replaceChild(newElement, this.dragHandle);
            }
        }
        this.dragHandle = null;
        this.container = null;
        this.isDragging = false;
    }
}
//# sourceMappingURL=WidgetDragController.js.map